import React from 'react';
import styled from 'styled-components';

interface PluginBrowseBetterProps {
    width?: number;
    height?: number;
}

const StyledSVG = styled.svg`
    display: block;
`;

export const PluginBrowseBetter: React.FC<PluginBrowseBetterProps> = ({
    width = 56,
}) => (
    <StyledSVG
        viewBox="0 0 100 100"
        width={width}
        height={width * 1}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="MVP---Plug-&amp;-Play-"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="Plugin---Assets"
                transform="translate(-120.000000, -2293.000000)"
            >
                <rect
                    fill="#0C1B2B"
                    x="0"
                    y="0"
                    width="1440"
                    height="3108"
                ></rect>
                <g
                    id="icn/USP/BrowseBetter"
                    transform="translate(120.000000, 2293.000000)"
                >
                    <path
                        d="M88,20.5 L88.5,38.5 L99,38.5 L99.5,93 L47,93.5 L46.5,81.5 L1,81.5 L0.5,21 L88,20.5 Z"
                        id="Combined-Shape"
                        stroke="#3F5365"
                    ></path>
                    <g
                        id="Group-8"
                        transform="translate(52.459016, 48.263937)"
                        stroke="#32CBCB"
                        strokeLinecap="round"
                    >
                        <line
                            x1="1"
                            y1="4.29878049"
                            x2="1"
                            y2="30.0914634"
                            id="Line-4"
                        ></line>
                        <line
                            x1="6"
                            y1="12.8963415"
                            x2="6"
                            y2="21.4939024"
                            id="Line-4-Copy"
                        ></line>
                        <line
                            x1="11"
                            y1="9.45731707"
                            x2="11"
                            y2="24.9329268"
                            id="Line-4-Copy-2"
                        ></line>
                        <line
                            x1="16"
                            y1="6.01829268"
                            x2="16"
                            y2="28.3719512"
                            id="Line-4-Copy-3"
                        ></line>
                        <line
                            x1="21"
                            y1="0.859756098"
                            x2="21"
                            y2="33.5304878"
                            id="Line-4-Copy-4"
                        ></line>
                        <line
                            x1="26"
                            y1="9.45731707"
                            x2="26"
                            y2="24.9329268"
                            id="Line-4-Copy-5"
                        ></line>
                        <line
                            x1="31"
                            y1="6.01829268"
                            x2="31"
                            y2="28.3719512"
                            id="Line-4-Copy-6"
                        ></line>
                        <line
                            x1="36"
                            y1="11.1768293"
                            x2="36"
                            y2="21.4939024"
                            id="Line-4-Copy-7"
                        ></line>
                        <line
                            x1="41"
                            y1="14.6158537"
                            x2="41"
                            y2="19.7743902"
                            id="Line-4-Copy-8"
                        ></line>
                    </g>
                    <rect
                        id="Rectangle"
                        stroke="#3F5365"
                        x="32.5"
                        y="24.5"
                        width="26"
                        height="10"
                        rx="5"
                    ></rect>
                    <rect
                        id="Rectangle"
                        stroke="#ADB7BF"
                        x="46.5"
                        y="38.5"
                        width="53"
                        height="55"
                        rx="1"
                    ></rect>
                    <line
                        x1="3.5"
                        y1="19.5"
                        x2="3.5"
                        y2="16.5"
                        id="Line-5"
                        stroke="#3F5365"
                        strokeLinecap="square"
                    ></line>
                    <line
                        x1="85.5"
                        y1="19.5"
                        x2="85.5"
                        y2="16.5"
                        id="Line-5-Copy"
                        stroke="#3F5365"
                        strokeLinecap="square"
                    ></line>
                    <line
                        x1="82.5"
                        y1="14.5"
                        x2="82.5"
                        y2="11.5"
                        id="Line-5-Copy-2"
                        stroke="#3F5365"
                        strokeLinecap="square"
                    ></line>
                    <line
                        x1="79.5"
                        y1="9.5"
                        x2="79.5"
                        y2="6.5"
                        id="Line-5-Copy-5"
                        stroke="#3F5365"
                        strokeLinecap="square"
                    ></line>
                    <line
                        x1="6.5"
                        y1="14.5"
                        x2="6.5"
                        y2="11.5"
                        id="Line-5-Copy-3"
                        stroke="#3F5365"
                        strokeLinecap="square"
                    ></line>
                    <line
                        x1="9.5"
                        y1="9.5"
                        x2="9.5"
                        y2="6.5"
                        id="Line-5-Copy-4"
                        stroke="#3F5365"
                        strokeLinecap="square"
                    ></line>
                    <line
                        x1="12.5"
                        y1="4.5"
                        x2="12.5"
                        y2="1.5"
                        id="Line-5-Copy-6"
                        stroke="#3F5365"
                        strokeLinecap="square"
                    ></line>
                    <line
                        x1="76.5"
                        y1="4.5"
                        x2="76.5"
                        y2="1.5"
                        id="Line-5-Copy-7"
                        stroke="#3F5365"
                        strokeLinecap="square"
                    ></line>
                    <line
                        x1="3.5"
                        y1="15.5"
                        x2="85.5"
                        y2="15.5"
                        id="Line-6"
                        stroke="#3F5365"
                        strokeLinecap="square"
                    ></line>
                    <line
                        x1="6.5"
                        y1="10.5"
                        x2="82.5"
                        y2="10.5"
                        id="Line-6-Copy"
                        stroke="#3F5365"
                        strokeLinecap="square"
                    ></line>
                    <line
                        x1="9.5"
                        y1="5.5"
                        x2="79.5"
                        y2="5.5"
                        id="Line-6-Copy-2"
                        stroke="#3F5365"
                        strokeLinecap="square"
                    ></line>
                    <line
                        x1="12.5"
                        y1="0.5"
                        x2="76.5"
                        y2="0.5"
                        id="Line-6-Copy-3"
                        stroke="#3F5365"
                        strokeLinecap="square"
                    ></line>
                </g>
            </g>
        </g>
    </StyledSVG>
);

export default PluginBrowseBetter;
